<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M9 5.25C4.86 5.25 1.5 6.93 1.5 9c0 1.68 2.205 3.098 5.25 3.578V15l3-3-3-3v2.047C4.388 10.627 3 9.622 3 9c0-.795 2.28-2.25 6-2.25S15 8.205 15 9c0 .547-1.095 1.418-3 1.898v1.537c2.648-.578 4.5-1.898 4.5-3.435 0-2.07-3.36-3.75-7.5-3.75Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
